module.exports = __webpack_public_path__ + "img/Z81_11.40c8c6c0.jpg";